import React from 'react';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-content">
        <div className="top-bar-item">
          <svg className="top-bar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#666"/>
          </svg>
          <a href="tel:+5491154076524" className="top-bar-link">+54 9 11 5407 6524</a>
        </div>
        
        <div className="top-bar-item">
          <svg className="top-bar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#666"/>
          </svg>
          <a href="mailto:jas@sopranografica.com.ar" className="top-bar-link">jas@sopranografica.com.ar</a>
        </div>
        
        <div className="top-bar-item">
          <svg className="top-bar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" fill="#666"/>
          </svg>
          <a href="https://www.facebook.com/sopranografica/" target="_blank" rel="noopener noreferrer" className="top-bar-link">Facebook</a>
        </div>
        
        <div className="top-bar-item">
          <svg className="top-bar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" fill="#666"/>
          </svg>
          <a href="/catalogo.pdf" target="_blank" rel="noopener noreferrer" className="top-bar-link">Catálogo</a>
        </div>
        
        <div className="top-bar-item">
          <svg className="top-bar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" fill="#666"/>
          </svg>
          <a href="http://www.sopranografica.com.ar/webmail" target="_blank" rel="noopener noreferrer" className="top-bar-link">Webmail</a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;

